export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5578.39a6ea46.jpg";